/** Switch locale client-side, persist preference, and reload. */
export async function switchAppLanguage(
  languageCode: string,
  changeLanguage: (code: string) => void,
): Promise<void> {
  changeLanguage(languageCode);

  try {
    await fetch('/api/user/preferred-language', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ language: languageCode }),
    });
  } catch {
    // Local cookie + reload still apply the switch.
  }

  if (typeof window !== 'undefined') {
    window.location.reload();
  }
}
